import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/twilio-credentials'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'GENERAL_SETTINGS.TWILIO_CRED',
        icon: 'call-start',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'twilio_credentials',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
